/**
 * @generated SignedSource<<7bbb1336f019dc44560ceb461d1d1b02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContractStatus = "active" | "deleted" | "expired" | "offer_draft" | "offer_made" | "offer_processing" | "offer_rejected" | "offer_revoked" | "paused" | "rejected";
export type JobApplicationStatus = "deleted" | "freelancer_not_interested" | "hired" | "interview" | "job_application_draft" | "job_application_invited" | "job_application_sent" | "job_viewed" | "offer" | "potential" | "rejected" | "screening_completed" | "screening_rejected" | "screening_requested" | "screening_started";
import { FragmentRefs } from "relay-runtime";
export type ApplicationStepsButton_JobApplication$data = {
  readonly contract: {
    readonly status: ContractStatus;
  } | null | undefined;
  readonly contractRequests: ReadonlyArray<{
    readonly __typename: "ContractRequest";
  }> | null | undefined;
  readonly latestInterview: {
    readonly __typename: "Interview";
  } | null | undefined;
  readonly status: JobApplicationStatus;
  readonly " $fragmentType": "ApplicationStepsButton_JobApplication";
};
export type ApplicationStepsButton_JobApplication$key = {
  readonly " $data"?: ApplicationStepsButton_JobApplication$data;
  readonly " $fragmentSpreads": FragmentRefs<"ApplicationStepsButton_JobApplication">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplicationStepsButton_JobApplication",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ContractRequest",
      "kind": "LinkedField",
      "name": "contractRequests",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Contract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Interview",
      "kind": "LinkedField",
      "name": "latestInterview",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "JobApplication",
  "abstractKey": null
};
})();

(node as any).hash = "1921ee0ae83971d49379fd7a1cd3f047";

export default node;
